import { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import api from '../../../services/api';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Loading from '../../../load/loading';
import HeaderSession from '../../../utils/headerSession';
import { Card, Paper, Typography } from '@mui/material';
import RegisterAccess from '../../../utils/registerAccess';
import { makeStyles } from '@material-ui/core';
import ListaVazia from '../../../utils/listaVazia';
import Date from '../../../utils/date';
import FerramentaNavegacaoExportacao from '../../../utils/paginacao';


const useStyles = makeStyles((theme) => ({
  hover: { '&:hover': { backgroundColor: '#85287d8a' }, cursor: 'pointer' },
}))

const ListaSolicitacoesAnalise = ({ thisStatus }) => {
  const classes = useStyles();
  const { id } = useParams()
  const { status } = useParams()
  const [solicitacoes, setSolicitacoes] = useState('');
  // const [status, setStatus] = useState(thisStatus);
  const navigate = useNavigate();
  const [configLista, setConfigLista] = useState('')
  const [perPage, setPerPage] = useState(50)
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));

  useEffect(() => {
    setSolicitacoes('');
    api.get(`/solicitacao-anlises?status=${status}&perPage=${perPage}&page=${page}`)
      .then(response => {
        // console.log(response)
        setSolicitacoes(response.data.solicitacaoAnalises)
        setConfigLista(response.data)
      }).catch(err => {
        // console.log(err)
      })
  }, [status, id, status, perPage, page])


  return (

    <>
      <RegisterAccess page={'lista de solicitações de analise'} />
      {/* SOLICITAÇÕES DE FARMACOVIGILÂNCIA */}
      {!id &&
        <HeaderSession title={'SOLICITAÇÕES DE ANÁLISE LABORATORIAL DE AMOSTRAS DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE'} />
      }
      <br />

      {solicitacoes ?
        solicitacoes.length > 0 ?

          <Card sx={{ width: '100%', overflow: 'hidden' }} >
            <TableContainer sx={{ border: "1px black" }} component={Paper}>
              <Table sx={{ border: "1px", borderColor: "black" }}>
                <TableHead sx={{ backgroundColor: "#dcdede" }}>
                  <TableRow>
                    <TableCell align="center" ><Typography noWrap> <strong> Solicitado por </strong></Typography></TableCell>
                    <TableCell align="center" ><Typography noWrap> <strong> Tipo de remetente </strong></Typography></TableCell>
                    <TableCell align="center" ><Typography noWrap> <strong> Entidade </strong></Typography></TableCell>
                    <TableCell align="center" ><Typography noWrap> <strong> Quantidade de produtos </strong></Typography></TableCell>
                    {/* <TableCell align="center" ><Typography noWrap> <strong> Forma farmacêutica </strong></Typography></TableCell> */}
                    <TableCell align="center" ><Typography noWrap> <strong> Nº de registo</strong></Typography></TableCell>
                    {/* <TableCell align="center" ><Typography noWrap> <strong> Condições de armazenamento de amostra á chegada do LNCQ </strong></Typography></TableCell> */}
                    <TableCell align="center" ><Typography noWrap> <strong> Grau de urgência </strong></Typography></TableCell>
                    <TableCell align="center" ><Typography noWrap> <strong> Estado </strong></Typography></TableCell>
                    <TableCell align="center" ><Typography noWrap> <strong> Data da entrada </strong></Typography></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {solicitacoes.map((solicitacao) => (
                    <TableRow key={solicitacao._id} className={classes.hover} onClick={() => { navigate(`/admin/dcqmts/gest/solicitacao-de-analise/${solicitacao._id}`) }}>
                      <TableCell ><Typography noWrap> {solicitacao?.remetidoPor?.nome}</Typography></TableCell>
                      <TableCell  ><Typography noWrap> {solicitacao?.tipoRemetente}</Typography></TableCell>
                      <TableCell  ><Typography noWrap> {solicitacao?.nome}</Typography></TableCell>
                      <TableCell  ><Typography > {solicitacao?.productos?.length}</Typography></TableCell>
                      <TableCell  ><Typography > {solicitacao?.numero}</Typography></TableCell>
                      <TableCell ><Typography noWrap> {solicitacao?.grauUrgencia ?? 'Urgente'}</Typography></TableCell>
                      <TableCell align="center" ><Typography noWrap> {solicitacao?.status}</Typography></TableCell>
                      <TableCell align="center" ><Typography noWrap> <Date date={solicitacao?.createdAt} /> </Typography></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <FerramentaNavegacaoExportacao
              configLista={configLista}
              lista={solicitacoes}
              page={page}
              setPage={setPage}
              setPerPage={setPerPage}
            // setOrder={setOrder}
            />
          </Card>
          :
          <ListaVazia />
        :
        <Loading text={'A carregar solicitações'} />
      }
    </>
  )
}

export default ListaSolicitacoesAnalise 
